// Static quiz copy — pulled verbatim from brief §6 (sport order, emojis, helper text).

import type { SportSlug, BettingStyleSlug, PlatformFeatureSlug, StakeBand } from '../types';

export const SPORTS: Array<{ slug: SportSlug; emoji: string; label: string }> = [
  { slug: 'football', emoji: '\u26BD', label: 'Football' },
  { slug: 'horse_racing', emoji: '\uD83C\uDFC7', label: 'Horse Racing' },
  { slug: 'tennis', emoji: '\uD83C\uDFBE', label: 'Tennis' },
  { slug: 'golf', emoji: '\u26F3', label: 'Golf' },
  { slug: 'cricket', emoji: '\uD83C\uDFCF', label: 'Cricket' },
  { slug: 'basketball_nba', emoji: '\uD83C\uDFC0', label: 'Basketball / NBA' },
  { slug: 'nfl_us_sports', emoji: '\uD83C\uDFC8', label: 'NFL / US Sports' },
  { slug: 'esports', emoji: '\uD83C\uDFAE', label: 'eSports' },
];

export const BETTING_STYLES: Array<{ slug: BettingStyleSlug; label: string }> = [
  { slug: 'singles', label: 'Singles \u2014 I back individual outcomes' },
  { slug: 'accas', label: 'Accas \u2014 I love building 3+ leg multiples' },
  { slug: 'in_play', label: 'In-play \u2014 I bet live as events unfold' },
  { slug: 'each_way', label: 'Each-way \u2014 mainly horse racing' },
  { slug: 'value_hunting', label: 'Value hunting \u2014 I look for mispriced odds' },
];

export const STAKE_BANDS: Array<{ slug: StakeBand; label: string }> = [
  { slug: '5-9', label: '\u00A35\u2013\u00A39 \u2014 I prefer lower risk qualifying bets' },
  { slug: '10-19', label: '\u00A310\u2013\u00A319 \u2014 comfortable with standard qualifying bets' },
  { slug: '20-plus', label: '\u00A320+ \u2014 happy to stake more for a bigger return' },
];

export const FEATURES: Array<{ slug: PlatformFeatureSlug; emoji: string; label: string }> = [
  { slug: 'cash_out', emoji: '\uD83D\uDCB0', label: 'Cash Out' },
  { slug: 'live_streaming', emoji: '\uD83D\uDCFA', label: 'Live Streaming' },
  { slug: 'bet_builder', emoji: '\uD83D\uDD27', label: 'Bet Builder' },
  { slug: 'acca_insurance', emoji: '\uD83D\uDEE1\uFE0F', label: 'Acca Insurance' },
  { slug: 'price_boosts', emoji: '\uD83D\uDCC8', label: 'Price Boosts' },
  { slug: 'betting_exchange', emoji: '\uD83D\uDD01', label: 'Betting Exchange' },
  { slug: 'tote_pools', emoji: '\uD83D\uDC0E', label: 'Tote Pools' },
];
